import { useQuery } from '@tanstack/react-query';

import { participantProjectsControllerGetParticipantPaidCount } from '@/api/core-api';
import { getClient } from '@/utils/get-api-client';

import { queryKeys } from './query-keys';

export function usePaidCount(userId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.paidCount.byUserId(userId ?? ''),
    queryFn: async () => {
      if (!userId) throw new Error('User ID is required');

      const response =
        await participantProjectsControllerGetParticipantPaidCount({
          path: { userId },
          client: getClient(userId),
        });

      if (response.error) {
        throw new Error('Failed to fetch paid count');
      }

      return response.data;
    },
    enabled: !!userId,
  });
}
